<template>
    <el-drawer
        title="训练题目管理"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="80%"
        :before-close="close">
        <div class="panel fx-g1">
            <div class="panel_head fx fx-m_between fx-c_start">
                <el-form :inline="true" :model="form" >
                </el-form>
            </div>
            <div class="panel_body">
                <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%;overflow: auto"
                    @selection-change="handleChoose"
                >
                    <el-table-column property="date" label="任务" min-width="150">
                        <template slot-scope="scope">
                            {{scope.row.title}}
                        </template>
                    </el-table-column>
                     <el-table-column property="date" label="知识点" min-width="250">
                        <template slot-scope="scope">
                            <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="500"
                        label="资料">
                        <template slot-scope="scope">
                            <div class="grid col-4 hgap-5">
                                <div class="fx fx-c_center" v-if="scope.row.videos.length > 0">
                                    讲解视频：
                                        <el-button  type="text" @click="setShowResources(scope.row.videos)"  size="medium" class="text_warn">查看</el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.attachments.length > 0">
                                    随堂资料：
                                        <el-button type="text" @click="setShowResources(scope.row.attachments)" size="medium" class="text_warn">查看</el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.codes.length > 0">
                                    代码：
                                        <el-button type="text" @click="viewCode(scope.row.codes[0].id)" size="medium" class="text_warn">查看</el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.tutorials.length > 0">
                                    卡片：
                                        <el-button type="text" @click="setShowResources(scope.row.tutorials)" size="medium" class="text_warn">查看</el-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
<!--                     <el-table-column
                        label="操作"
                        min-width="180"
                        >
                        <template slot-scope="scope">
                            <el-popconfirm @onConfirm="remove(scope.row)"
                                           title="确认移除该题目吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false" ><i class="iconfont icon-shanchu"></i><b>移除</b></el-link>
                            </el-popconfirm>
                        </template>
                </el-table-column>-->
                </el-table>
            </div>
            <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
            <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>
        </div>
        <span  class="fx fx-center">
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
.no_set {
    width: 55px;
    text-align: center;
}
.task_info{
    height: 40px;
    font-size: 12px;
    border-top: 1px solid var(--border);
}
.task_info:first-child{
    border-top: none;
}
.task_info .el-link {
    color: #f29100;
}
.lesson_info i.iconfont,.task_info i.iconfont {
    vertical-align: text-top;
}
.task_info > span {
    margin-right: 30px;
}
</style>


<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    export default {
        props: [
            "item"
        ],
        components: {
            ResourceDrawer,
            VideoDrawer,
        },
        data() {
            return {
                show: false,
                showResources: false,
                showVideo:false,
                currentVideo: null,
                currentResources: [],
                needRefreshParent: false,
                form: {
                    keywords: "",
                    enable: true,
                    // ...this.item
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },
        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {

                    this.$emit("close");
                }
            },
            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources =true;
            },
            viewCode(id) {
                //语言类型optType
                window.goEditCode(this.item.optType, `mode=caseview&id=${id}`);
            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            handleChoose(val) {
                this.choosedList = val;
            },
            loadData() {
                this.$ajaxPost("/challengeRoundLink/getSchoolTaskOneByTrainModuleId", {
                    trainModuleId: this.item.id,
                }, (data) => {
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.tableData = items;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            remove(item){
                this.$ajaxGet("/challengeRoundLink/del/"+ this.item.id +"-"+item.id, (data) => {
                    this.loadData();
                    this.$showSuccess("操作成功", 600, ()=>{
                            this.$emit("submit");
                        });
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            console.log(this.item)
            this.loadData();
        }


    }
</script>
